export const promoEnums = {
    DATOS : 1,
    DIAMADRE : 2,
    SORTEO : 3,
    BANNERS : 4,
}
